<script>
  import { sortedUniq, groupBy, forEach } from "lodash-es";

  let files;
  let source = [];
  let leo = [];
  let copypaste = "";

  /**
   * Load upload json file and attach it to source
   * @param e
   */
  const onFileSelected = (e) => {
    let image = e.target.files[0];
    let reader = new FileReader();
    reader.readAsText(image);
    reader.onload = (e) => {
      let preSource = JSON.parse(e.target.result) || [];
      source = preSource;
      console.log("source", preSource);
    };
  };

  /**
   * Invert color
   */
  const invertColor = (color, group, pax, all) => {
    console.log("color", color, group, pax, all);
    return all[pax]["value"];
  };

  /**
   * Reversed values of an array
   * for dark mode
   */
  const getReversed = (group) => {
    let colors = source.colors[group];
    const allKeys = Object.keys(colors);
    let colorCount = Object.keys(colors).length;

    let reversed = {};
    let i = colorCount;

    for (const [key, value] of Object.entries(colors)) {
      const reversedName = allKeys[i - 1];
      i--;
      reversed[key] = {
        value: invertColor(key, value, reversedName, colors),
        comment: value.comment,
      };
    }
    source.colors[group] = reversed;
  };

  /**
   * Check if name matches color blocks
   */

  const checkTokenName = (name) => {
    const regex = /([a-zA-Z]+)([0-9]+)/;
    return regex.test(name);
  };

  function extractNumbers(str) {
    const regex = /\d+/g;
    return str.match(regex)?.join("");
  }

  /**
   * Create a new color object
   */

  const createColorObject = (leoColors, level) => {
    let objected = {};

    forEach(leoColors, (value, key) => {
      const xx = key.toLowerCase();
      objected[xx] = {};

      forEach(value, (x) => {
        console.log("x", xx, x.number);
        let number = new String(x.number);
        objected[xx][number] = level[x.original];
      });
    });

    const newSource = {
      colors: objected,
    };

    // console.log('test', objected);
    source = newSource;
  };

  /**
   * Filter Names
   */

  const doFilterNames = (items) => {
    const newx = [];
    items.map((item) => {
      const extNo = extractNumbers(item);
      const extName = item.replace(extNo, "");

      const newObj = {
        name: extName,
        number: extNo,
        original: item,
      };

      if (extNo) {
        newx.push(newObj);
      }
    });

    return sortedUniq(newx);
  };

  const onLoad = () => {
    console.log("loaded");
  };

  /**
   * Load files from Leo
   */
  const onFileSelectedLeo = (e) => {
    let image = e.target.files[0];
    let reader = new FileReader();
    reader.readAsText(image);
    reader.onload = (e) => {
      let preSource = JSON.parse(e.target.result) || [];
      leo = preSource;
      handleLeo(leo);
    };
  };

  const handleLeo = (leo) => {
    // Loop through Leo
    const keyx = Object.keys(leo);
    const firstItem = leo[keyx];

    // get level 2 categories
    const l2 = Object.keys(firstItem);

    const resultsx = doFilterNames(l2);
    const grouped = groupBy(resultsx, "name");

    createColorObject(grouped, firstItem);
  };

  /**
   * Export JSON
   */

  const exportNow = () => {
    console.log("exporting", source);
    let dataStr =
      "data:text/json;charset=utf-8," +
      encodeURIComponent(JSON.stringify(source));
    let downloadAnchorNode = document.createElement("a");
    downloadAnchorNode.setAttribute("href", dataStr);
    downloadAnchorNode.setAttribute("download", "data.json");
    document.body.appendChild(downloadAnchorNode); // required for firefox
    downloadAnchorNode.click();
    downloadAnchorNode.remove();
  };

  /**
   *
   */

  const pasteNow = () => {
    console.log("pasting", copypaste);
    let preSource = JSON.parse(copypaste) || [];
    leo = preSource;
    handleLeo(leo);
  };
</script>

<main>
  <div class="flex">
    <div class="left">
      <h1>Amazon Style Dictionary Editor</h1>
      <input
        type="file"
        accept=".json"
        on:change={(e) => onFileSelected(e)}
        bind:this={files}
      />
    </div>
    <div class="right">
      {#if source && source.colors}
        <button class="btn--primary" on:click={exportNow}>Export</button>
        <span class="subtitle">Export Results as JSON</span>
      {/if}
    </div>
  </div>
  <div>
    {#if source && source.colors}
      <h1>Color Library</h1>
      <div class="m">
        {#each Object.entries(source.colors) as [key, name]}
          <div class="color">
            <p class="color__name">{key}</p>
            <div class="color__blocks">
              {#each Object.entries(name) as [xkey, xname]}
                <div class="block" style="background-color: {xname['value']}" />
              {/each}
              <div class="block block-right">
                <button class="icon" on:click={getReversed(key)}>
                  <svg
                    class="nile-icon"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M5.99986 16.5001L18.9999 16.5001"
                      stroke="#000000"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M8.39825 19.9999L4.99986 16.4999L8.39825 12.9999"
                      stroke="#000000"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M17.9999 7.49991L4.99989 7.50016"
                      stroke="#000000"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M15.6015 11.0002L18.9999 7.50016L15.6015 4.00018"
                      stroke="#000000"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </button>
              </div>
            </div>
          </div>
        {/each}
      </div>
    {/if}
  </div>

  <div class="flex flex-c">
    <h4>Load from Leo</h4>
    <input
      type="file"
      accept=".json"
      on:change={(e) => onFileSelectedLeo(e)}
      bind:this={files}
      style="display: none"
    />
    <textarea bind:value={copypaste} />
    <button on:click={pasteNow}>Paste from Leo</button>
  </div>
</main>

<style>
  .flex-c {
    flex-direction: column;
  }
  @font-face {
    font-family: "colfax";
    src: url("https://use.typekit.net/af/bac079/00000000000000003b9acde4/27/l?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n4&v=3")
        format("woff2"),
      url("https://use.typekit.net/af/bac079/00000000000000003b9acde4/27/d?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n4&v=3")
        format("woff"),
      url("https://use.typekit.net/af/bac079/00000000000000003b9acde4/27/a?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n4&v=3")
        format("opentype");
    font-display: auto;
    font-style: normal;
    font-weight: normal;
  }

  @font-face {
    font-family: "colfax";
    src: url("https://use.typekit.net/af/522c51/00000000000000003b9acde6/27/l?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n5&v=3")
        format("woff2"),
      url("https://use.typekit.net/af/522c51/00000000000000003b9acde6/27/d?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n5&v=3")
        format("woff"),
      url("https://use.typekit.net/af/522c51/00000000000000003b9acde6/27/a?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n5&v=3")
        format("opentype");
    font-display: auto;
    font-style: normal;
    font-weight: bold;
  }

  body {
    font-family: colfax, sans-serif;
  }

  /* end load fonts */

  * {
    -webkit-font-smoothing: subpixel-antialiased;
    -webkit-overflow-scrolling: touch;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
    -webkit-text-size-adjust: none;
    -webkit-touch-callout: none;
    box-sizing: border-box;
  }
  .block {
    width: 15%;
    height: 48px;
    /* margin-right: 9px; */
  }
  .color {
    margin-bottom: 24px;
    border-bottom: solid 1px #ddd;
    padding-bottom: 24px;
  }
  .color__name {
    display: block;
    margin-top: 6px;
    margin-bottom: 12px;
    font-size: 14px;
    color: #555;
    text-transform: uppercase;
  }
  .color__blocks {
    display: flex;
  }
  .nile-icon {
    width: 24px;
    height: 24px;
  }
  main {
    text-align: left;
    padding: 1em;
    max-width: 60ch;
    margin: 0 auto;
  }

  h1 {
    color: #000;
    font-size: var(--nile-type-scale-4);
  }

  h2 {
    color: #000;
    font-size: var(--nile-type-scale-3);
  }

  .color__blocks {
    display: flex;
    widows: 100%;
  }
  .block-right {
    text-align: right;
  }
  .icon {
    background: none;
    border: none;
    color: #000;
    font-size: 14px;
    cursor: pointer;
    border: solid 1px #ddd;
    font-size: 13px;
    padding: 6px 12px;
    border-radius: 4px;
  }
  .flex {
    display: flex;
  }

  .right {
    text-align: revert;
    margin-left: auto;
  }

  .subtitle {
    font-size: 13px;
    display: block;
    margin-bottom: 9px;
  }

  .btn--primary {
    font-family: colfax;
    font-size: 13px;
    border: 0;
    padding: 9px 12px;
    background-color: green;
    color: #fff;
    border-radius: 6px;
  }
</style>
